<div class="h-100 d-flex flex-column generic-chat-layout">
  <div class="d-flex chat-top-headers">
    <div class="w-25 ch-hd-1 d-flex flex-grow-1">
      <div class="d-flex description">
        <strong> Workspace </strong>
        <span class="sub-header"> AI-powered Support</span>
      </div>
      <div class="d-flex proj-name">
        <span class="project-name-tooltip" [attr.data-tooltip]="projectName">{{projectName}}</span>
      </div>
    </div>
    <div class="w-75 ch-hd-2 d-flex">
      <div class="flex-grow-1 font-item-header">
        {{ getDisplayMessage() }}
      </div>
      <div class="mx-4 d-flex">
        <button type="button" class="accello-icon-btn mx-2" [disabled]="true" matTooltip="Task summary" (mousedown)="isSumActive = true"
          (mouseup)="isSumActive = false" (mouseleave)="isSumActive = false">
          <img [src]="
              isSumActive
                ? 'assets/images/virtusa-icons/summary.svg'
                : 'assets/images/virtusa-icons/summary-light.svg'
            " />
        </button>
        <button type="button" class="accello-icon-btn" [disabled]="true" matTooltip="Open in new tab"
          (mousedown)="isActive = true" (mouseup)="isActive = false" (mouseleave)="isActive = false">
          <img [src]="
              isActive
                ? 'assets/images/virtusa-icons/new-tab-dark.svg'
                : 'assets/images/virtusa-icons/new-tab.svg'
            " />
        </button>
      </div>
    </div>
  </div>
  <div class="layout-body d-flex">
    <div class="w-25 bordered rounded h-100">
      <app-agentic-chat (onEmit)="onChatEmit($event)" [viewId]="viewId" [sendInput]="message" [projectId]="projectId" [automationProjectId]="automationProjectId"
        [threadId]="threadId" [messages]="messages" [isInputDisabled]="disableInput || isProgressTracking">
      </app-agentic-chat>
    </div>

    <div class="w-75 generic-layout-wrap h-100 px-3 pt-3"
      [class.overflow-auto]="!isTrsMetricView()"
      [class.overflow-hidden]="isTrsMetricView()"
      [class.card-state]="response?.result && response.result.length > 0">

      <!-- Loop through result array and render components based on type -->
      <ng-container *ngIf="response?.result && response.result.length > 0">
        <div *ngFor="let item of response.result" [ngClass]="item.class" class="h-100">
          <ng-container [ngSwitch]="item.type">
            <app-ui-object-table *ngSwitchCase="'uiObjectTable'" [tableData]="item?.data"></app-ui-object-table>

            <!-- Expandable Detail User Story Table Component -->
             <!-- <app-expand-table-component *ngSwitchCase="'expandable_detail_table'" [columns]="item.data?.columns"
              [rows]="item.data?.rows" (selectionChange)="onTableChange($event)" (openReportEvent)="openReport($event)">
            </app-expand-table-component> -->

             <!-- [showHeaderActions]="item.id === 'test_case_table'" -->
            <app-expandable-accordion *ngSwitchCase="'expandable_detail_table'" 
              [data]="getItemData(item)"
              [showHeaderActions]="item.id === 'test_case_table'"
              [showInlineFeedbackPanel]="false"
              [testCoverageConfigs]="item?.testCoverageConfigs"
              [templateId]="item.id"
              [info]="getInfoOptions(item.id)"
              [descriptionImage]="getDescriptionImage(item.id)"
              (actionEmit)="onTableChange($event)">
            </app-expandable-accordion>
            `
            <ng-container *ngIf="item?.formattedData">
              <app-editable-table *ngSwitchCase="'editableTable'" [tableData]="item?.formattedData"
                (onSaveData)="onTableSave($event, item?.data)">
              </app-editable-table>
            </ng-container>

            <!-- Generic Accordion Table View -->
            <ng-container *ngSwitchCase="'accordion_table'">
              <app-accordion-table-view 
                [sections]="item.data"
                [typeId]="item?.id"
                [itemLabel]="getAccordionConfig(item?.id).itemLabel"
                [paginationInfo]="getAccordionConfig(item?.id).paginationInfo"
                [sortOptions]="sortOptions"
                [showHeader]="true"
                [hideTcCount]="isTcCountHidden(item?.id)"
                [info]="getInfoOptions(item.id)"
                [tableOptions]="getTableOptions(item.id)"
                [showPagination]="item.data?.length > 1"
                [showSectionCheckbox]="getIsSelectionEnable(item.id)"
                [autoExpandFirst]="getAccordionConfig(item?.id).autoExpandFirst"
                (sortChange)="onSortChange($event)"
                (sectionCheckboxChange)="onSectionCheckboxChange($event)"
                (sectionExpand)="onSectionExpand($event)"
                (tableRowSelect)="onTableRowSelect($event)"
                (tableActions)="onTableActions($event)"
                (infoIconClick)="onInfoIconClick($event, item?.id)">
              </app-accordion-table-view>
            </ng-container>

            <!-- According table view TSG-->
            <app-accordion-table-view 
              *ngSwitchCase="'application_list'"
              [sections]="item.data"
              [typeId]="item?.id"
              [itemLabel]="'Page(s)'"
              [paginationInfo]="getPaginationInfo('applications', 1)"
              [sortOptions]="sortOptions"
              [showHeader]="true"
              [showPagination]="item.data?.length > 1"
              [showSectionCheckbox]="true"
              (sectionCheckboxChange)="onSectionCheckboxChange($event)"
              (sortChange)="onSortChange($event)"
              (sectionExpand)="onSectionExpand($event)"
              (tableRowSelect)="onTableRowSelect($event)"
              (tableActions)="onTableActions($event)">
            </app-accordion-table-view>

             <!-- According table view TSG expandable auto-->
            <app-accordion-table-view 
              *ngSwitchCase="'application_in_detail'"
              [sections]="item.data"
              [typeId]="item?.id"
              [itemLabel]="'Page(s)'"
              [paginationInfo]="getPaginationInfo('applications', 1)"
              [sortOptions]="sortOptions"
              [showHeader]="true"
              [showPagination]="item.data?.length > 1"
              [autoExpandFirst]="true"
              (sortChange)="onSortChange($event)"
              (sectionExpand)="onSectionExpand($event)"
              (tableRowSelect)="onTableRowSelect($event)"
              (tableActions)="onTableActions($event)">
            </app-accordion-table-view>

            <!-- Accordion Test Execution with toolbar header; config driven by item.id -->
            <ng-container *ngSwitchCase="'accordion_table_test_execution'">
              <app-accordion-table-view
                [sections]="item.data"
                [typeId]="item?.id"
                [itemLabel]="'Test Case(s)'"
                [showHeader]="true"
                [showTestPlanHeader]="true"
                [showSaveButton]="true"
                [isSaveLoading]="isSaveLoading"
                [selectAllSectionsOnly]="getTestExecConfig(item.id).selectAllSectionsOnly"
                [showSectionCheckbox]="getTestExecConfig(item.id).showSectionCheckbox"
                [showPagination]="item.data?.length > 5"
                [pageSize]="10"
                [dropdown1Options]="executionEngineOptions"
                [dropdown2Options]="browserOptions"
                [dropdown1Placeholder]="'Execution Engine/Device'"
                [dropdown2Placeholder]="'Browser'"
                [dropdown1RowKey]="'agentId'"
                [dropdown2RowKey]="'browser'"
                (sectionCheckboxChange)="onTestExecutionCheckboxChange($event)"
                (selectAllChange)="onUnifiedTestExecSelectAll($event, item.id)"
                (switchToggle)="onTestExecutionDefaultToggle($event)"
                (dropdown1Change)="onTestExecutionEngineChange($event)"
                (dropdown2Change)="onTestExecutionBrowserChange($event)"
                (saveClick)="onTestExecutionSave($event)"
                (sectionExpand)="onSectionExpand($event)"
                (tableRowSelect)="onTableRowSelect($event)"
                (tableActions)="onTableActions($event)">
              </app-accordion-table-view>
            </ng-container>

            <!-- Knowledge Graph Component -->
            <app-knowledge-graph *ngSwitchCase="'knowledge_graph_details'" [data]="item" [isAgentic]="true">
            </app-knowledge-graph>

            <app-knowledge-graph *ngSwitchCase="'unified_knowledge_graph_details'" [data]="item" [isAgentic]="true">
            </app-knowledge-graph>

            <div *ngSwitchCase="'progress_bar'" class="v-center m-auto w-75 h-100">
              <div *ngIf="isProgressTracking" class="agentic-progress-wrap" [class.has-logs]="showProcessLogsPanel">
                <app-progress-bar
                  [text]="progress.text"
                  [progress]="progress.percentage"
                  [isError]="progress.isError"></app-progress-bar>
                <div class="d-flex justify-content-end mt-2" *ngIf="item.id === 'test_case_progress'">
                  <button class="btn-accello-secondary" (click)="cancelTCG()">
                    Cancel
                  </button>
                </div>
                <div class="process-logs" *ngIf="showProcessLogsPanel">
                  <button
                    type="button"
                    class="process-logs-thinking-header"
                    (click)="toggleProcessLogsExpanded()"
                  >
                    <div class="mat-spinner-wrap" *ngIf="progress.percentage < 100 && !progress.isError">
                      <mat-spinner diameter="14"></mat-spinner>
                    </div>
                    <img
                      *ngIf="progress.percentage >= 100 || progress.isError"
                      class="process-log-icon"
                      src="assets/images/virtusa-icons/agent/check-circle.svg"
                      alt="done"
                    />
                    <span class="thinking-label">
                      {{ progress.percentage >= 100 ? 'Completed' : (progress.isError ? 'Failed' : 'Thinking...') }}
                    </span>
                    <i
                      class="bi"
                      [ngClass]="isProcessLogsExpanded ? 'bi-chevron-down' : 'bi-chevron-right'"
                    ></i>
                  </button>

                  <div class="process-logs-timeline" *ngIf="isProcessLogsExpanded">
                    <div
                      class="process-log-row is-completed"
                      *ngFor="let evaluation of completedEvaluations"
                    >
                      <div class="process-log-rail">
                        <img
                          class="process-log-icon"
                          src="assets/images/virtusa-icons/agent/check-circle.svg"
                          alt="completed"
                        />
                      </div>
                      <div class="process-log-text">{{ evaluation }}</div>
                    </div>

                    <div class="process-log-row is-live" *ngIf="liveThinkingText as thinkingText">
                      <div class="process-log-rail">
                        <img
                          class="process-log-icon"
                          src="assets/images/virtusa-icons/thinking_icon.svg"
                          alt="thinking"
                        />
                      </div>
                      <div class="process-log-text">{{ thinkingText }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- TDG Combined Table Component with Tabs -->
            <app-multi-tab-table *ngSwitchCase="'tdg_combined_table_details'" [result]="item?.data"
              (tableRowSelect)="onTdgTableChange($event)" (selectedTab)="onSelectedTab($event)"
              (onAction)="onTdgActionChange($event, item?.data)">
            </app-multi-tab-table>
            <!-- High Impact Details (Impacted Test Cases + Modified Code Files tabs) -->
            <ng-container *ngSwitchCase="'impacted_testcases_table'">
              <app-high-impact-details
                [impactedTestCaseData]="item?.data"
                [mappingId]="item?.mappingId"
                (actionEmit)="onTableActions($event)">
              </app-high-impact-details>
            </ng-container>

            <!-- High Impact Details (Most Impacted Test Cases + Modified Code Files tabs) -->
            <ng-container *ngSwitchCase="'most_impacted_testcases_table'">
              <app-high-impact-details
                [impactedTestCaseData]="item?.data"
                [mappingId]="item?.mappingId"
                [reportName]="item?.reportName"
                [type]="'most_impacted'"
                (actionEmit)="onTableActions($event)">
              </app-high-impact-details>
            </ng-container>

            <!-- Generic Table -->
            <app-zorro-table *ngSwitchCase="'table'" [enableHorizontalScroll]="true"
              [columns]="item?.formattedData?.columns" [data]="item?.formattedData?.data" [options]="tableOptions">
            </app-zorro-table>

            <!-- Execution Cycle Status Card -->
            <app-execution-cycle-status-card
              *ngSwitchCase="'execution_result'"
              [projectId]="projectId"
              [automationProjectId]="automationProjectId"
              [executionId]="item?.data?.id"
              (viewResults)="onViewResults($event)">
            </app-execution-cycle-status-card>

            <!-- Table with Header -->
             <ng-container *ngSwitchCase="'table-view-agentic'">
              <app-table-with-header
              [projectId]="projectId"
              [meta]="getTableMeta(item?.id)"
              [columns]="item?.columns"
              [rows]="item?.data"
              [viewId]="item?.id"
              (onComponentAction)="onTHComponentOutput($event, item?.id)"
            ></app-table-with-header>
             </ng-container>
             
            <!-- table view Code mappings with Coverage progress-->
             <ng-container *ngSwitchCase="'code_coverage_table'">
              <app-table-with-header
              [projectId]="projectId"
              [meta]="getTableMeta(item?.id)"
              [columns]="item?.columns"
              [rows]="item?.data"
              [viewId]="item?.id"
              [showProgressBar]="true"
              [progressBarValue]="item.coverage"
              [progressBarLabel]="'Overall Code Coverage'"
              [showSaveButton]="true"
              [headerType]="'coverageDetails'"
              [isHighImpactSaveLoading]="highImpactSaving"
              (highImpactSaveClick)="saveTestCoverage(item.mappingId)"
              (onComponentAction)="onTHComponentOutput($event, item?.id)"
              ></app-table-with-header>
             </ng-container>

             <div class="container-fluid bg-white p-0 test-report" *ngSwitchCase="'trs_all_metrics_data'">
              <nz-tabset
                  [nzSelectedIndex]="activeGroupIndex"
                  (nzSelectedIndexChange)="activeGroupIndex = $event"
                  class="trs-tab-set">
                  <nz-tab *ngFor="let group of item?.data?.metricGroups" [nzTitle]="getGroupTitle(group)">
                    <!-- TRS Release Header inside tab content -->
                    <div class="trs-release-header d-flex align-items-center justify-content-between mb-2 border rounded"
                      *ngIf="item?.data?.metadata || item?.data?.releases?.length">
                      <div class="d-flex align-items-center gap-2" *ngIf="item?.data?.metadata?.startDate && item?.data?.metadata?.endDate">
                        <img src="assets/images/virtusa-icons/calendar.svg" width="16" alt="date range"
                          onerror="this.style.display='none'" />
                        <span class="trs-date-range">{{ formatTrsDateRange(item.data.metadata) }}</span>
                      </div>
                      <div *ngIf="item?.data?.releases?.length">
                        <nz-select
                          [(ngModel)]="selectedTrsRelease"
                          (ngModelChange)="onTrsReleaseChangeForMetricData($event, item)"
                          [nzDisabled]="isLoading"
                          class="trs-release-select">
                          <nz-option
                            *ngFor="let rel of item.data.releases"
                            [nzValue]="rel.value"
                            [nzLabel]="rel.label">
                          </nz-option>
                        </nz-select>
                      </div>
                    </div>
                    <div class="row card-container pt-2 metric-view">
                      <app-metric-card-view
                        *ngFor="let metric of group.metrics"
                        [metric]="metric"
                        [ngClass]="getTileClass(metric.size)"
                      ></app-metric-card-view>
                    </div>
                  </nz-tab>
                </nz-tabset>
              </div>

             <div class="container-fluid bg-white p-0 test-report" *ngSwitchCase="'trs_single_metric_data'">
              <!-- TRS Release Header -->
              <div class="trs-release-header d-flex align-items-center justify-content-between mb-2 border rounded"
                *ngIf="item?.data?.metadata || item?.data?.releases?.length">
                <div class="d-flex align-items-center gap-2" *ngIf="item?.data?.metadata?.startDate && item?.data?.metadata?.endDate">
                  <img src="assets/images/virtusa-icons/calendar.svg" width="16" alt="date range"
                    onerror="this.style.display='none'" />
                  <span class="trs-date-range small">{{ formatTrsDateRange(item.data.metadata) }}</span>
                </div>
                <div *ngIf="item?.data?.releases?.length">
                  <nz-select
                    [(ngModel)]="selectedTrsRelease"
                    (ngModelChange)="onTrsReleaseChangeForMetricData($event, item)"
                    [nzDisabled]="isLoading"
                    class="trs-release-select">
                    <nz-option
                      *ngFor="let rel of item.data.releases"
                      [nzValue]="rel.value"
                      [nzLabel]="rel.label">
                    </nz-option>
                  </nz-select>
                </div>
              </div>
                <div class="row card-container pt-2 trs-single-card-container">
                  <app-metric-card-view
                    *ngFor="let metric of item?.data?.metricGroups[0]?.metrics"
                    [metric]="metric"
                    [ngClass]="getTileClass(item?.data?.metricGroups[0]?.metrics?.length > 1 ? metric.size : null)"
                  ></app-metric-card-view>
                </div>
             </div>
          </ng-container>
        </div>
      </ng-container>
      <div *ngIf="isLoading" class="d-flex flex-column justify-content-center align-items-center h-100">
        <app-loading class="h-100 loading-container" [text]="'Loading'"></app-loading>
      </div>
    </div>
  </div>
</div>